import type { UpdateEntry } from "@/types/domain";

/** 示例动态；date/tag/title/summary/body 走 i18n（UpdatesPage:items.<slug>.*） */
export const UPDATES: UpdateEntry[] = [
  { slug: "phase-one-kickoff" },
  { slug: "integrated-prototype" },
  { slug: "controlled-water-testing" },
  { slug: "approved-pond-window" },
  { slug: "ams-report-archive" },
];

export function getUpdate(slug: string): UpdateEntry | undefined {
  return UPDATES.find((u) => u.slug === slug);
}
